import { ArrowRightAltRounded } from '@mui/icons-material'
import { ButtonBase, Card, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useSelector } from 'react-redux'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { BagIcon, InvoiceIcon, ProfitIcon, WomanIcon } from '../../../../../atoms/icons'
import HeaderSkeleton from '../../../../common/skeletons/HeaderSkeleton'

export default function ContentBody() {

    const currentShop = useSelector(selectCurrrentAdminShop)
    
    
    return (
        <>
            {
                !currentShop ? (
                    <HeaderSkeleton />
                ):(
                    <Stack direction="row" spacing={2} >

                        <Card variant="outlined" sx={styles.cardMin}>

                            {/* <Stack direction="column" sx={{height: "100%"}} flex justifyContent="space-between"> */}
                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <ProfitIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Gross Revenue</Typography>
                                        <Typography variant="h6" > GH₵ {currentShop.gross_revenue}</Typography>
                                    </Typography>

                                </Stack>

                                {/* <Stack direction="row" flex alignItems="center" justifyContent="space-between" > */}
                                <Stack direction="row" alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                            
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            {/* <Stack direction="column" sx={{height: "100%"}} flex justifyContent="space-between"> */}
                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <InvoiceIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Gross Profit</Typography>
                                        <Typography variant="h6" > GH₵ {currentShop.gross_profit}</Typography>
                                    </Typography>

                                </Stack>

                                {/* <Stack direction="row" flex alignItems="center" justifyContent="space-between" > */}
                                <Stack direction="row" alignItems="center" justifyContent="space-between" >

                                <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                    <ArrowRightAltRounded htmlColor={grey[500]} />
                                </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            {/* <Stack direction="column" sx={{height: "100%"}} flex justifyContent="space-between"> */}
                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <BagIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Average Basket Value</Typography>
                                        <Typography variant="h6" >20</Typography>
                                    </Typography>

                                </Stack>

                                {/* <Stack direction="row" flex alignItems="center" justifyContent="space-between" > */}
                                <Stack direction="row" alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            {/* <Stack direction="column" sx={{height: "100%"}} flex justifyContent="space-between"> */}
                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <WomanIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Best Shopkeeper</Typography>
                                        <Typography variant="h6" > Adwoa Fosu</Typography>
                                    </Typography>

                                </Stack>

                                {/* <Stack direction="row" flex alignItems="center" justifyContent="space-between" > */}
                                <Stack direction="row" alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >View employee performance</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>


                    </Stack>
                )
            }
        </>
    )
}





const styles = {

    cardMin:{
        flex: 1, 
        borderRadius: "4px", 
        backgroundColor: 'primary.main',
        // backgroundColor: 'primary.dark',
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        padding: "1rem"
    },

}